export default "__VITE_ASSET__SUVcI9UC__"